import React, { useCallback } from 'react';
import { AnalyticsListener, useAnalyticsEvents } from '@atlaskit/analytics-next';
const ATLASKIT_CHANNEL = 'atlaskit';

/**
 * Lets your treat analytics-next events as a Event API events.
 * Also see {@link createAtlaskitToEventChannelRepackager} if you just want to repackage "atlaskit" channel events.
 */
export const createAnalyticsNextToEventChannelRepackager = (useEventDispatch, channel) => {
  const RepackageAnalyticsNextEvent = ({
    children,
    ...uiProperties
  }) => {
    const dispatchAnalytics = useEventDispatch();
    const repackageAtlaskitEvent = useCallback(event => {
      dispatchAnalytics({
        ...uiProperties,
        ...event.payload,
        attributes: {
          ...uiProperties.attributes,
          ...event.payload.attributes
        }
      });
    }, [dispatchAnalytics, uiProperties]);
    return /*#__PURE__*/React.createElement(AnalyticsListener, {
      channel: channel,
      onEvent: repackageAtlaskitEvent
    }, children);
  };
  return RepackageAnalyticsNextEvent;
};

/**
 * Lets your treat atlaskit events as a event channel created from {@link createBaseAnalyticsChannel}.
 * The atlaskit channel gets its own special helper method because it's such a common usecase.
 */
export const createAtlaskitToEventChannelRepackager = useEventDispatch => {
  const RepackageAtlaskitEvent = createAnalyticsNextToEventChannelRepackager(useEventDispatch, 'atlaskit');
  return RepackageAtlaskitEvent;
};
/**
 * Returns an object that listens to events and fires them as an Atlaskit event on a
 * specified channel
 */
export const createEventChannelToAnalyticsNextRepackager = (Listener, channel = ATLASKIT_CHANNEL) => {
  return ({
    children
  }) => {
    const {
      createAnalyticsEvent
    } = useAnalyticsEvents();
    const fireAsAtlaskitEvent = useCallback(payload => {
      createAnalyticsEvent(payload).fire(channel);
    }, [createAnalyticsEvent]);
    return /*#__PURE__*/React.createElement(Listener, {
      onEvent: fireAsAtlaskitEvent
    }, children);
  };
};